module.exports = __webpack_public_path__ + "static/img/Mitch-Duke.f217693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mitch-Duke.jpg
// module id = ZXi2
// module chunks = 0